(function () {
	'use strict';

	angular.module('dcApp').run(startupRun);

	startupRun.$inject = [
		'$trace',
		'$transitions',
		'$log',
		'$q',
		'$rootScope',
		'$state',
		'$filter',
		'$http',
		'$injector',
		'$stateParams',
		'$window',
		'$cookies',
		'$location',
		'$timeout',
		'CommonServices',
		'UserService',
		'ParametersServices',
		'gettextCatalog',
		'ProjectStorage',
		'ConnectionStorage',
		'ProjectService',
		'toaster',
		'InitializationService',
		'AppSelectorService',
		'API_BASE_URL_BACKEND',
		'DATE_PATTERN',
		'DATE_TIME_PATTERN',
		'CURRENT_LOCATION_NAME',
		'DATE_TIME_PATTERN_MN',
		'FILTER_DATE_PATTERN',
		'STORAGE_SUFFIX',
		'LANG_NAME',
		'APP_BUILD',
		'MEMBER_ROLE_NAME',
		'PROJECT_ROLE_NAME',
		'CONSOLE_ROLE_NAME',
		'ADMIN_ROLE_NAME',
		'GOUV_ROLE_NAME',
		'SELECTED_MENU',
		'WEB_SOCKET_TOPICS',
		'NO_ACCESS',
	];

	function startupRun(
		$trace,
		$transitions,
		$log,
		$q,
		$rootScope,
		$state,
		$filter,
		$http,
		$injector,
		$stateParams,
		$window,
		$cookies,
		$location,
		$timeout,
		CommonServices,
		UserService,
		ParametersServices,
		gettextCatalog,
		ProjectStorage,
		ConnectionStorage,
		ProjectService,
		toaster,
		InitializationService,
		AppSelectorService,
		API_BASE_URL_BACKEND,
		DATE_PATTERN,
		DATE_TIME_PATTERN,
		CURRENT_LOCATION_NAME,
		DATE_TIME_PATTERN_MN,
		FILTER_DATE_PATTERN,
		STORAGE_SUFFIX,
		LANG_NAME,
		APP_BUILD,
		MEMBER_ROLE_NAME,
		PROJECT_ROLE_NAME,
		CONSOLE_ROLE_NAME,
		ADMIN_ROLE_NAME,
		GOUV_ROLE_NAME,
		SELECTED_MENU,
		WEB_SOCKET_TOPICS,
		NO_ACCESS
	) {
		// $trace.enable('TRANSITION');
		// retry every 5 seconds
		let retryWebSocketConnectDelay = 5000;
		let datePatternMappings = undefined;
		let defaultTZ = undefined;

		const LanguageMapping = {
			BROWSER: 'browser',
			FR: 'fr',
			EN: 'en',
		};

		$rootScope.API_BASE_URL_BACKEND = API_BASE_URL_BACKEND;
		$rootScope.jobCacheActive = true;
		$rootScope.filtersParam = {};
		$rootScope.sessionExpirationFirstAlertDelay = 600;
		$rootScope.sessionExpirationLastAlertDelay = 60;
		// VARIABLES
		$rootScope.hasDefaultUserRoleActive = false;
		$rootScope.apiPaths = undefined;
		$rootScope.dataGirdCaptionsTra = undefined;
		$rootScope.sessionDelayAlertPopupOptions = undefined;
		$rootScope.sessionDelayLastAlertPopupOptions = undefined;
		$rootScope.inactivityAlertPopupOptions = undefined;
		$rootScope.currentLangCode = undefined;
		$rootScope.currentProject = undefined;
		$rootScope.currentProjectId = undefined;
		$rootScope.currentProjectVersion = undefined;
		$rootScope.stompClient = undefined;
		$rootScope.jobTypes = undefined;
		$rootScope.availableTimezones = undefined;
		$rootScope.availableDateLanguages = undefined;
		$rootScope.selectedMenu = undefined;

		// ROLES
		$rootScope.hasUserRole = undefined;
		$rootScope.hasGouvRole = undefined;
		$rootScope.hasMemberRole = undefined;
		$rootScope.hasProjectRole = undefined;
		$rootScope.hasAdminRole = undefined;
		$rootScope.userIsAdmin = undefined;
		$rootScope.userRoles = new Set();

		$rootScope.goTo = goTo;
		$rootScope.fetchConnectedUser = getConnectedUser;
		$rootScope.getSelectedLang = getSelectedLang;
		$rootScope.isUserAdmin = isUserAdmin;
		$rootScope.logout = executeOnLogout;
		$rootScope.checkError = checkError;
		$rootScope.checkErrorBoolean = checkErrorBoolean;
		$rootScope.getDateWithPattern = getDateWithPattern;
		$rootScope.getDateTimeWithPattern = getDateTimeWithPattern;
		$rootScope.getDateTimeWithPatternMn = getDateTimeWithPatternMn;
		$rootScope.getDateTimeWithPatternFilter = getDateTimeWithPatternFilter;
		$rootScope.getFormattedDateWithPattern = getFormattedDateWithPattern;
		$rootScope.getLastLoginDate = getLastLoginDate;
		$rootScope.getUrl = getUrl;
		$rootScope.translateSimpleTypes = translateSimpleTypes;
		$rootScope.havePermission = havePermission;
		$rootScope.getRunningJob = getRunningJob;
		$rootScope.mapTags = mapTags;
		$rootScope.getCorrespondentDatePattern = getCorrespondentDatePattern;
		$rootScope.getDefaultTimezone = getDefaultTimezone;
		$rootScope.getCenteringTooltip = getCenteringTooltip;

		$rootScope.static_elements_data = {
			GD: {
				icons: {
					datablock: 'fal fa-table',
					entity: 'far fa-credit-card-front',
					repository: 'far fa-boxes',
					connector: 'far fa-plug',
				},
				links: {
					datablock: '/datablocks',
					entity: '/entites',
					repository: '/depots',
					connector: '/connectors',
				},
				labels: {
					datablock: 'DataBlocks',
					entity: 'Entités Métier',
					repository: 'Dépôts',
					connector: 'Connecteurs',
				},
			},
			HD: {
				icons: {
					map: 'fas fa-map-marked-alt',
					chart: 'far fa-chart-line',
					grid: 'fas fa-table',
					media: 'far fa-photo-video',
					timeline: 'far fa-line-height',
					dashboard: 'fas fa-file-medical-alt',
					exposition: 'fas fa-share-alt',
				},
				links: {
					map: '/maps',
					chart: '/charts',
					grid: '/grids',
					media: '/medias',
					timeline: '/timelines',
					dashboard: '/dashboards',
					exposition: '/expositions',
				},
				labels: {
					map: 'Cartes',
					chart: 'Graphiques',
					grid: 'Tableaux',
					media: 'Médias',
					timeline: 'TimeLine',
					dashboard: 'Tableaux de Bord',
					exposition: 'exposition.name',
				},
			},
		};

		init();

		function init() {
			initEvents();
			initVariables();
		}

		function getConnectedUser() {
			return fetchConnectedUser()
				.then((accountData) => {
					$rootScope.currentProject =
						AppSelectorService.getSelectedProjectLabel();
					$rootScope.currentProjectId =
						AppSelectorService.getSelectedProjectId();
					$rootScope.visibleSessionDelayAlertPopup = false;
					$rootScope.visibleSessionDelayLastAlertPopup = false;
					$rootScope.selectedMenu =
						$window.sessionStorage.getItem(SELECTED_MENU) ?? 'gd-home';

					$rootScope.account = generateAccountData(accountData);

					setLanguageAndLoadAjsTrad($rootScope.account.lang.code);
					loadCommonTra();
					return InitializationService.initAvailablePaths().then(() => {
						return $q.all({
							loadCacheActiveStatus: loadCacheActiveStatus(),
							lastLoginDate: UserService.getBeforeLastLoginDate(),
							sessionExpirationDelay: UserService.getSessionExpirationDelay(),
							jobTypes: InitializationService.initJobTypes(),
							availableTimezones:
								InitializationService.initAvailableTimezones(),
							availableDateLanguages:
								InitializationService.initAvailableDateLanguages(),
							datePatternMappings:
								InitializationService.initDatePatternMappings(),
							defaultTimezone: InitializationService.initDefaultTimezone(),
						});
					});
				})
				.then(onAllResolved)
				.catch((error) => {
					console.error(error);
				});
		}

		function isUserAdmin() {
			$rootScope.userIsAdmin = $rootScope.userRoles.has(ADMIN_ROLE_NAME);
			return $rootScope.userIsAdmin;
		}

		function generateAccountData(accountData) {
			const selectedLanguage = parseLang(
				LanguageMapping[accountData.preferences.language]
			);
			return {
				...accountData,
				lang: { code: selectedLanguage },
				userId: accountData.uuid,
				preferredUsername: accountData.login,
			};
		}

		function onAllResolved(res) {
			$log.debug(res);
			if (res.availablePaths) {
				$rootScope.apiPaths = res.availablePaths;
			}

			if (res.lastLoginDate.data) {
				let date = moment(res.lastLoginDate.data);
				$rootScope.lastLoginDate = date.format('LLLL');
			}

			if (res.sessionExpirationDelay.data) {
				$rootScope.sessionExpirationDelay = res.sessionExpirationDelay.data;
				if (
					$rootScope.sessionExpirationDelay <=
					$rootScope.sessionExpirationLastAlertDelay
				) {
					showSessionExpirationLastAlert();
				} else if (
					$rootScope.sessionExpirationDelay <=
					$rootScope.sessionExpirationFirstAlertDelay
				) {
					showSessionExpirationFirstAlert();
				} else {
					$timeout(function () {
						showSessionExpirationFirstAlert();
					}, ($rootScope.sessionExpirationDelay -
						$rootScope.sessionExpirationFirstAlertDelay) *
						1000);
				}
			}

			if (res.jobTypes) {
				$rootScope.jobTypes = res.jobTypes;
			}

			if (res.availableTimezones) {
				$rootScope.availableTimezones = res.availableTimezones;
			}

			if (res.availableDateLanguages) {
				$rootScope.availableDateLanguages = res.availableDateLanguages;
			}

			if (res.datePatternMappings) {
				datePatternMappings = res.datePatternMappings;
			}

			if (res.defaultTimezone) {
				defaultTZ = res.defaultTimezone;
			}

			$log.warn('listen on web socket');
			//connect on web socket
			connectOnWebSocket();

			return $q.resolve();
		}

		function getSelectedLang() {
			return LanguageMapping[$rootScope.account['preferences'].language];
		}

		function getUrl(code) {
			if ($rootScope.apiPaths === null || $rootScope.apiPaths === undefined) {
				$rootScope.apiPaths = InitializationService.getAvailablePaths();
			}
			return $rootScope.apiPaths[code];
		}

		function translateSimpleTypes(types) {
			let translatedTypes = [];
			for (let i in types) {
				translatedTypes[i] = types[i];
				translatedTypes[i].lib = $rootScope.simpleTypesTra[types[i].lib]
					? $rootScope.simpleTypesTra[types[i].lib]
					: types[i].lib;
			}
			return translatedTypes;
		}

		function loadCacheActiveStatus() {
			const deferred = $q.defer();
			let status = AppSelectorService.getIsJobsCacheActive();
			if (status) {
				$rootScope.jobCacheActive = status;
				deferred.resolve($rootScope.jobCacheActive);
			} else {
				// FIXME unreachable code at startup since if no project is present default value of cache status is true
				ParametersServices.getCacheStatus().then(
					function (response) {
						$rootScope.jobCacheActive = response.data;
						AppSelectorService.setIsJobsCacheActive($rootScope.jobCacheActive);
						deferred.resolve($rootScope.jobCacheActive);
					},
					function (e) {
						$log.error(e);
						$rootScope.jobCacheActive = true;
						AppSelectorService.setIsJobsCacheActive($rootScope.jobCacheActive);
						deferred.reject(e);
					}
				);
			}
			return deferred.promise;
		}

		function setLanguageAndLoadAjsTrad(currentLangCode) {
			$rootScope.currentLangCode = currentLangCode;
			InitializationService.setCurrentLanguage(currentLangCode);
			$http.defaults.headers.common['Accept-Language'] = currentLangCode;
		}

		function havePermission(permission) {
			// FIXME: moves condition on element ex: ng-if= $rootScope.userIsAdmin || havePermission('permission')
			//  permission string should be a constant
			if ($rootScope.userIsAdmin) {
				return true;
			}

			if ($rootScope.globalPermissions) {
				return $rootScope.globalPermissions.indexOf(permission) > -1;
			}

			return false;
		}

		function executeOnLogout() {
			$log.debug('logout');
			$rootScope.account = null;
			$rootScope.isLoggedOut = true;
			delete $rootScope.lastLoginDate;
			_logout();
		}

		function goTo(state, hasTargetProject, selectedMenu) {
			$rootScope.selectedMenu =
				selectedMenu !== undefined ? selectedMenu : state;
			$window.sessionStorage.setItem(SELECTED_MENU, $rootScope.selectedMenu);
			if (hasTargetProject !== undefined && hasTargetProject) {
				$state.go(state, {
					projectId: AppSelectorService.getSelectedProjectId(),
				});
			} else {
				$state.go(state);
			}
		}

		async function fetchConnectedUser() {
			const response = await $http.get('/account');
			const data = response.data;
			$rootScope.account = data;
			if (!data['accounts'] || data['accounts'].length === 0) {
				return $q.resolve(data);
			}

			// user has direct roles
			if (data['accounts'][0]['user_roles']) {
				applyRoles(data['accounts'][0]['user_roles']);
			}

			// user is a member of available groups and has inherited  roles
			if (data['accounts'][0]['groups']) {
				data['accounts'][0]['groups'].forEach((group) => {
					applyRoles(group['roles']);
				});
			}
			if (!$rootScope.hasUserRole) {
				$rootScope.hasUserRole = $rootScope.userRoles.size !== 0;
			}
			return $q.resolve(data);
		}

		function applyRoles(roles) {
			if (roles.indexOf(ADMIN_ROLE_NAME) !== -1) {
				$rootScope.userRoles.add(ADMIN_ROLE_NAME);
				$rootScope.hasAdminRole = true;
			}
			if (roles.indexOf(MEMBER_ROLE_NAME) !== -1) {
				$rootScope.userRoles.add(MEMBER_ROLE_NAME);
				$rootScope.hasMemberRole = true;
			}
			if (roles.indexOf(PROJECT_ROLE_NAME) !== -1) {
				$rootScope.userRoles.add(PROJECT_ROLE_NAME);
				$rootScope.hasProjectRole = true;
			}
			if (roles.indexOf(CONSOLE_ROLE_NAME) !== -1) {
				$rootScope.userRoles.add(CONSOLE_ROLE_NAME);
				$rootScope.hasUserRole = true;
			}
			if (roles.indexOf(GOUV_ROLE_NAME) !== -1) {
				$rootScope.userRoles.add(GOUV_ROLE_NAME);
				$rootScope.hasGouvRole = true;
			}
		}

		function loadCommonTra() {
			const translations = InitializationService.initCommonTranslations();
			$rootScope.dataGirdCaptionsTra = translations.dataGirdCaptions;
			$rootScope.errorTra = translations.errorTra;
			$rootScope.permissionsActionLabelsTrans =
				translations.permissionsActionLabels;
			$rootScope.simpleTypesTra = translations.simpleTypes;
			for (let key in translations.various) {
				$rootScope[key] = translations.various[key];
			}
		}

		function connectOnWebSocket() {
			$rootScope.$broadcast('loader_show');

			var socket = new SockJS(
				`${API_BASE_URL_BACKEND}${getUrl('STOMP_END_POINT')}`,
				null,
				{ timeout: 15000 }
			);

			$rootScope.stompClient = Stomp.over(socket);
			$rootScope.stompClient.debug = null;
			$rootScope.stompClient.connect(
				{ 'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN') },
				function (frame) {
					$rootScope.$broadcast('socketInit', undefined);

					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.user_replay,
						function (message) {
							$log.debug(message);
						}
					);

					//for all users and all contexts :
					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.global_running_jobs,
						function (message) {
							$rootScope.$broadcast('running', JSON.parse(message.body));
						}
					);
					//for all users and by context : update frame status after (un)persist
					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.global_jobs,
						function (message) {
							$log.debug(`[PERSIST] ${message.body}`);
							if (isForSelectedProject(message)) {
								broadcastMessage(message, 'job_global');
							}
						}
					);
					//for all users update context status
					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.global_context,
						function (message) {
							broadcastMessage(message, 'context_status_update');
						}
					);
					//only for private user
					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.user_private_job,
						function (message) {
							$log.debug(`[PRIVATE] ${message.body}`);
							broadcastMessage(message, 'job_private');
						}
					);

					//only for private user
					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.user_import_from_database_progress,
						function (message) {
							$rootScope.$broadcast(
								'import_db_progress',
								JSON.parse(message.body)
							);
						}
					);

					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.global_datablock,
						function (message) {
							if (isForSelectedProject(message)) {
								broadcastMessage(message, 'datablocks');
							}
						}
					);

					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.global_export_datablock,
						function (message) {
							$rootScope.$broadcast(
								'exportJobFinished',
								JSON.parse(message.body)
							);
						}
					);

					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.global_expose_datablock,
						function (message) {
							$log.debug(`[GLOBAL NOTIF EXPOSE]  ${message.body}`);
							if (isForSelectedProject(message)) {
								$rootScope.$broadcast('expose-job', JSON.parse(message.body));
							}
						}
					);

					// The job counter listens to 'running' above and stays global: this
					// channel is the one the screens read an element back from.
					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.global_running_jobs,
						function (message) {
							$log.debug(`[GLOBAL NOTIF] ${message.body}`);
							if (isForSelectedProject(message)) {
								$rootScope.$broadcast(
									'globalRunningJobs',
									JSON.parse(message.body)
								);
							}
						}
					);

					$rootScope.stompClient.subscribe(
						WEB_SOCKET_TOPICS.project_bulk_execution,
						function (message) {
							$rootScope.$broadcast('bulk_status', JSON.parse(message.body));
						}
					);
					$rootScope.$broadcast('loader_hide');
				},
				function () {
					$log.debug('Websocket connection failed');
					retryConnectToWebSocket();
				}
			);

			$rootScope.stompClient.ws.onclose = function () {
				$log.debug('Websocket connection closed');
				retryConnectToWebSocket();
			};
		}

		function disconnectFromSocket() {
			$log.debug('disconnecting from socket');
			if ($rootScope.stompClient) {
				$rootScope.stompClient.disconnect();
			}
		}

		function retryConnectToWebSocket() {
			$log.debug(
				`Retry connect to WebSocket after: ${retryWebSocketConnectDelay}`
			);

			setTimeout(function () {
				connectOnWebSocket();
			}, retryWebSocketConnectDelay);
		}

		function showSessionExpirationFirstAlert() {
			$rootScope.visibleSessionDelayAlertPopup = true;
			$timeout(function () {
				showSessionExpirationLastAlert();
			}, ($rootScope.sessionExpirationFirstAlertDelay -
				$rootScope.sessionExpirationLastAlertDelay) *
				1000);
		}

		function showSessionExpirationLastAlert() {
			$rootScope.visibleSessionDelayAlertPopup = false;
			$rootScope.visibleSessionDelayLastAlertPopup = true;
		}

		function getLastLoginDate() {
			return $rootScope.lastLoginDate;
		}

		// Two tabs share the session but not the project: an event naming one concerns
		// only the tab opened on it. Otherwise the other tab reads the element back with
		// its own project and the backend answers "element not found".
		// An event naming no project goes through: unknown is not "another project".
		function isForSelectedProject(message) {
			var projectId = JSON.parse(message.body).project_id;
			return (
				projectId === undefined ||
				projectId === null ||
				String(projectId) === String(AppSelectorService.getSelectedProjectId())
			);
		}

		function broadcastMessage(message, topic) {
			var messageData = JSON.parse(message.body);
			if (messageData.action === 'NEW_AUTHENTIFACTION_DETECTED') {
				$rootScope.newAuthenticationDetected = true;
				executeOnLogout(true);
			} else if (messageData.action === 'LOGOUT_BY_ADMIN') {
				$rootScope.logoutByAdmin = true;
				executeOnLogout(true);
			}
			// FIXME: attempting to change to a triple equal will break the fetch from job
			//  queue mechanism; need to store context as a number in the session storage
			//  instead of a string, before switching to a triple equal comparison
			else if (
				AppSelectorService.getSelectedCtxId() == messageData.context_id ||
				(messageData.shared_files_system &&
					(messageData.type === 'PersistFrame' ||
						messageData.type === 'UnPersistFrame'))
			) {
				$rootScope.$broadcast(topic, messageData);
			}
		}

		function checkError(fieldName) {
			return checkErrorBoolean(fieldName) ? 'has-error' : '';
		}

		function checkErrorBoolean(fieldName) {
			var isError = false;
			if ($rootScope.fields && $rootScope.fields.length > 0) {
				isError = contains($rootScope.fields, fieldName);
			}
			return isError;
		}

		function getDateWithPattern(date) {
			if (!date) {
				return '';
			}
			return $filter('date')(date, DATE_PATTERN);
		}

		function getDateTimeWithPattern(date) {
			if (!date) {
				return '';
			}
			return $filter('date')(date, DATE_TIME_PATTERN);
		}

		function getDateTimeWithPatternMn(date) {
			if (!date) {
				return '';
			}
			return $filter('date')(date, DATE_TIME_PATTERN_MN);
		}

		function getDateTimeWithPatternFilter(date) {
			if (!date) {
				return '';
			}
			return $filter('date')(date, FILTER_DATE_PATTERN);
		}

		function getFormattedDateWithPattern(date, pattern) {
			if (!date) {
				return '';
			}
			return $filter('date')(date, pattern ? pattern : DATE_TIME_PATTERN);
		}

		function _logout() {
			deleteLocalStorage();
			$window.location.href = '/logout';
		}

		function deleteLocalStorage(e) {
			$window.sessionStorage.clear();
		}

		function initEvents() {
			$transitions.onSuccess({}, function (transition) {
				$rootScope.$broadcast(
					'state:transition:success',
					transition.to().data['title']
				);
			});

			$transitions.onStart({ to: 'logged.*' }, function (transition) {
				// logic to add when transitioning to a new state
			});

			$transitions.onError({}, function (transition) {
				const error = transition.error();
				if (
					error &&
					error.detail &&
					error.detail.code &&
					error.detail.code === NO_ACCESS
				) {
					const toState = transition.to();
					$state.go(toState.data.redirectTo, transition.params());
				}
			});
		}

		function initVariables() {
			const devExtremeConfigs = InitializationService.initDevExtremeConfigs();
			$rootScope.sessionDelayAlertPopupOptions =
				devExtremeConfigs.sessionDelayAlertPopupOptions;
			$rootScope.sessionDelayLastAlertPopupOptions =
				devExtremeConfigs.sessionDelayLastAlertPopupOptions;
			$rootScope.inactivityAlertPopupOptions =
				devExtremeConfigs.inactivityAlertPopupOptions;
		}

		function getDefaultTimezone() {
			return defaultTZ ? defaultTZ : moment.tz.guess();
		}

		/**
					Map AngularJS date pattern to MomentJs Patterns
		 **/
		function getCorrespondentDatePattern(angularPattern) {
			return datePatternMappings.hasOwnProperty(angularPattern)
				? datePatternMappings[angularPattern]
				: angularPattern;
		}

		function getRunningJob(type) {
			if (!type) {
				return;
			}
			let jobType = _.find($rootScope.jobTypes, function (elm) {
				return elm.code === type;
			});
			return jobType ? jobType.value : type;
		}

		function mapTags(tags) {
			if (tags && tags.length <= 0) {
				return null;
			}

			return _.map(tags, function (item) {
				return item.code;
			});
		}

		function parseLang(langKey) {
			switch (langKey) {
				case 'en':
					return 'en';
				case 'fr':
					return 'fr';
				case 'browser': {
					const lang = navigator.language;

					if (lang === 'fr-FR' || lang === 'fr') {
						return 'fr';
					}
					if (lang === 'en-US' || lang === 'en') {
						return 'en';
					}
					break;
				}
			}
			return 'fr';
		}
	}
})();
